var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotebookIconHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 112,
    viewBox: "0 0 100 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 6L91.5692 30V78L50 102L8.43078 78V30L50 6Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5 5.13397C50.1906 4.95534 49.8094 4.95534 49.5 5.13397L7.93078 29.134C7.62138 29.3126 7.43078 29.6427 7.43078 30V78C7.43078 78.3573 7.62138 78.6874 7.93078 78.866L49.5 102.866C49.8094 103.045 50.1906 103.045 50.5 102.866L92.0692 78.866C92.3786 78.6874 92.5692 78.3573 92.5692 78V30C92.5692 29.6427 92.3786 29.3126 92.0692 29.134L50.5 5.13397Z",
    stroke: "#003E6B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.9001 32.4492H25V74.5201H62.9001V32.4492Z",
    fill: "#336589"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8909 32.4492H25V74.5201H31.8909V32.4492Z",
    fill: "#003E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8704 39.7026H37.9204V48.407H56.8704V39.7026Z",
    fill: "#CCD8E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4248 41.8789H41.3657V43.3296H53.4248V41.8789Z",
    fill: "#003E6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4248 44.7803H41.3657V46.231H53.4248V44.7803Z",
    fill: "#003E6B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3421 37.3726H67.7441V40.4024H71.3421V37.3726Z",
    fill: "#E0E1E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3421 32.4492H69.5296C69.2831 32.4492 69.0484 32.4886 68.8343 32.5589C68.7273 32.5941 68.6256 32.637 68.5312 32.6877C68.0563 32.9388 67.7441 33.3636 67.7441 33.8454V37.3727H71.3421V32.4492Z",
    fill: "#D75A4A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2495 32.4492C73.4855 32.4492 73.7103 32.4898 73.9153 32.5624C73.7103 32.4898 73.4855 32.4492 73.2495 32.4492Z",
    fill: "#D75A4A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9402 40.4023H71.3423V68.0495H74.9402V40.4023Z",
    fill: "#F9A44A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9402 37.3726H71.3423V40.4024H74.9402V37.3726Z",
    fill: "#C4C4C4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9593 33.8893C74.9593 33.3924 74.6604 32.9543 74.2056 32.6953C74.6604 32.9543 74.9593 33.3924 74.9593 33.8893Z",
    fill: "#D75A4A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9402 37.3727V33.8454C74.9402 33.3636 74.6281 32.9388 74.1532 32.6877C74.0587 32.6377 73.9562 32.5941 73.85 32.5589C73.636 32.4886 73.4012 32.4492 73.1547 32.4492H71.3423V37.3727H74.9402Z",
    fill: "#B74C44"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.94 68.0498H67.7441L71.3421 73.7307L74.94 68.0498Z",
    fill: "#A8937B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4429 74.3367C70.4429 74.6299 70.8449 74.8669 71.3423 74.8669C71.8398 74.8669 72.2418 74.6299 72.2418 74.3367V72.2158H70.4429V74.3367Z",
    fill: "#666666"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3421 40.4023H67.7441V68.0495H71.3421V40.4023Z",
    fill: "#F69144"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 10L87.1721 31.75V75.25L49.5 97L11.8279 75.25V31.75L49.5 10Z",
    fill: "#00AEEF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5858 65.4142C41.8047 64.6332 41.8047 63.3668 42.5858 62.5858L52.1716 53L42.5858 43.4142C41.8047 42.6332 41.8047 41.3668 42.5858 40.5858C43.3668 39.8047 44.6332 39.8047 45.4142 40.5858L56.4142 51.5858C57.1953 52.3668 57.1953 53.6332 56.4142 54.4142L45.4142 65.4142C44.6332 66.1953 43.3668 66.1953 42.5858 65.4142Z",
    fill: "#003E6B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.430664,
    y: 0,
    width: 99.1384,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebookIconHover);
export default __webpack_public_path__ + "static/media/notebook-icon-hover.82e1a291ec013464cf83ca2e8eaa30f6.svg";
export { ForwardRef as ReactComponent };